export default __webpack_public_path__ + "static/media/apiWhite.090a3ccb.svg";